<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 65 64"
>
  <g clip-path="url(#clip0_1695_7008)">
    <path
      d="M2.09314 11.4016C1.6178 6.68976 5.31698 2.59863 10.0527 2.59863H53.7201C58.3497 2.59863 62.0128 6.51632 61.7021 11.1355L58.7782 54.611C58.4957 58.8114 55.0061 62.0742 50.7962 62.0742H14.4386C10.3313 62.0742 6.89129 58.9638 6.47903 54.8772L2.09314 11.4016Z"
      fill="#7CA6B1"
    />
    <path
      d="M19.5273 14.7018L26.3096 22.3318C26.9151 21.4033 28.8772 19.5463 31.8807 19.5463C34.8843 19.5463 36.7656 21.4033 37.3307 22.3318L44.2341 14.7018C42.2963 13.2485 37.1127 10.3418 31.8807 10.3418C26.6487 10.3418 21.4651 13.2485 19.5273 14.7018Z"
      fill="#C0DBE3"
    />
    <path
      d="M60.9102 4.81299C58.7091 2.42969 55.586 1.0625 52.3419 1.0625H11.6661C8.42146 1.0625 5.29841 2.42969 3.09772 4.81299C0.897039 7.19678 -0.217708 10.4185 0.0405929 13.6523L3.20124 53.2608C3.43513 56.1924 4.75397 58.9063 6.91462 60.9014C9.07575 62.8965 11.8853 63.9951 14.8262 63.9951H49.1812C52.1226 63.9951 54.9322 62.8965 57.0933 60.9014C59.254 58.9058 60.5728 56.1924 60.8067 53.2608L63.9674 13.6523C64.2252 10.4185 63.1109 7.19678 60.9102 4.81299ZM60.2135 13.353L57.0528 52.9614C56.7276 57.0371 53.2701 60.2295 49.1812 60.2295H14.8262C10.7379 60.2295 7.28034 57.0371 6.95515 52.9614L3.7945 13.353C3.61725 11.1309 4.35261 9.00537 5.86433 7.36768C7.37653 5.73047 9.43708 4.82861 11.6661 4.82861H52.3419C54.5709 4.82861 56.6309 5.73047 58.1432 7.36768C59.6554 9.00537 60.3907 11.1309 60.2135 13.353Z"
      fill="#1D4F5D"
    />
    <path
      d="M32.0045 8.08496C26.7608 8.08496 21.8321 10.127 18.1255 13.835C17.3902 14.5708 17.3907 15.7627 18.1255 16.4976L25.129 23.501C25.482 23.8545 25.961 24.0527 26.4605 24.0527H26.462C26.962 24.0523 27.4415 23.853 27.794 23.499C28.9156 22.3735 30.4112 21.7539 32.0045 21.7539C33.5953 21.7539 35.0904 22.3735 36.2144 23.499C36.5675 23.8525 37.0484 24.0513 37.5484 24.0513C38.0479 24.0513 38.5269 23.8525 38.8795 23.4995L45.8814 16.4961C46.6168 15.7607 46.6168 14.5689 45.8814 13.8335C42.1749 10.1265 37.2467 8.08496 32.0045 8.08496ZM37.42 19.6333C36.3507 18.9126 35.1534 18.4175 33.8873 18.1704V16.8682C33.8873 15.8281 33.044 14.9854 32.0045 14.9854C30.9644 14.9854 30.1212 15.8281 30.1212 16.8682V18.1699C28.8541 18.417 27.6563 18.9121 26.587 19.6333L22.1973 15.2437C24.9815 13.0439 28.4014 11.8506 32.0045 11.8506C35.6065 11.8506 39.025 13.0435 41.8096 15.2427L37.42 19.6333Z"
      fill="#1D4F5D"
    />
  </g>
  <defs>
    <clipPath id="clip0_1695_7008">
      <rect width="64" height="64" fill="white" transform="translate(0.00390625)" />
    </clipPath>
  </defs>
</svg>
